
import babelPolyfill from 'babel-polyfill';

import { VueReCaptcha } from 'vue-recaptcha-v3'
Vue.use(VueReCaptcha, { siteKey: '6LdD31gaAAAAABVcVg6iPHiS3lMw29N5xRRMnKOm' });


import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'

import Vuex from 'vuex'

import axios from 'axios'
import VueAxios from 'vue-axios'

import VCalendar from 'v-calendar';

Vue.use(Vuex);

Vue.use(VCalendar);


Vue.use(VueAxios, axios)
const baseURL = 'https://serwis.inchcape.pl/api/';

//const baseURL = 'https://webapi.demo.csflow.pl/';

Vue.axios.defaults.baseURL = baseURL;

import SelectInput from './components/elements/select-input.vue';
Vue.component('SelectInput', SelectInput);


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


history.pushState(null, null, location.href);
window.onpopstate = function () {
  if (!window.confirm('Podane przez Ciebie dane zostaną zresetowane. Kontynuować?')) {
    history.go(1);
  }
};